import React from 'react';
import './DestinationWildlife.css';

function DestinationWildlife({ destination }) {
  return (
    <section className="destination-wildlife-section">
      <div className="destination-wildlife-container">
        <h2 className="destination-wildlife-title">Wildlife & Nature</h2>
        <p className="destination-wildlife-intro">
          Discover the incredible diversity of wildlife and natural wonders that call this destination home.
        </p>
        
        <div className="wildlife-grid">
          {destination.wildlife.map((animal, index) => (
            <div key={index} className="wildlife-item">
              <div className="wildlife-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <span className="wildlife-name">{animal}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DestinationWildlife;

